export default "__VITE_ASSET__BWxNiINt__"